/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:18]
Permissions to update outside the main branch: [true]
*/

import { useEffect, useRef } from 'react';
import Environment from 'utils/environmentUtils';
import { AssertIsWidget } from './WidgetClass';

const uri = Environment.GetWidgetUri();
const path = Environment.GetWidgetPath();
const src = Environment.GetWidgetSrc();

const Widget = () => {
    const widgetRef = useRef<HTMLElement>(null);

    useEffect(() => {
        const script = document.createElement('script');

        script.src = src;
        script.async = true;
        script.onload = () => {
            const widget = document.querySelector('w-widget');

            if (widget && document.readyState !== 'loading') {
                AssertIsWidget(widget);
            }
        };

        widgetRef.current && widgetRef.current.appendChild(script);

        return () => {
            widgetRef?.current?.removeChild(script);
        };
    }, []);

    return (
        <aside ref={widgetRef}>
            <w-widget cdn-path={path} crm-uri={uri} offset-y="0.5rem" offset-x="0.9rem"></w-widget>
        </aside>
    );
};

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'w-widget': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}

export default Widget;
